import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-success",
  "use": "icon-success-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-success\">\n<g id=\"icon-success_success\">\n<path id=\"icon-success_Vector\" d=\"M31.9997 58.6673C46.7273 58.6673 58.6663 46.7282 58.6663 32.0007C58.6663 17.2731 46.7273 5.33398 31.9997 5.33398C17.2721 5.33398 5.33301 17.2731 5.33301 32.0007C5.33301 46.7282 17.2721 58.6673 31.9997 58.6673Z\" fill=\"#67C23A\" />\n<path id=\"icon-success_Vector_2\" d=\"M42.6663 24L27.9997 40L21.333 32.7273\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/success.svg
// module id = C5yd
// module chunks = 45